var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1632_706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96591 10.8891L8.27841 12.2189L7.96591 13.4265C7.23875 13.4265 6.35744 13.596 5.72369 13.3365C5.0515 13.0612 4.63431 12.3425 4.12891 11.8372L4.75391 10.5873L5.92344 10.043C6.44591 10.5658 7.16822 10.8891 7.96591 10.8891Z",
    fill: "#EE61EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92325 10.0425V10.0428L4.12872 11.837C3.63778 11.3461 2.92797 10.7927 2.65338 10.1436C2.37875 9.49431 2.53934 8.74925 2.53934 8L3.88534 7.6875L5.07709 8C5.07713 8.79731 5.40044 9.51962 5.92325 10.0425Z",
    fill: "#0065A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.92341 5.95759C5.4006 6.4804 5.07725 7.20274 5.07725 8.00009H2.5395C2.5395 7.32462 2.31919 6.45924 2.54472 5.86274C2.8195 5.13596 3.5896 4.70237 4.12888 4.16309L5.45857 4.8678L5.92341 5.95759Z",
    fill: "#99EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96569 2.57356L8.27819 3.84366L7.96569 5.11097C7.16769 5.11097 6.44569 5.43463 5.92319 5.95744L4.12866 4.16291C4.6196 3.67197 4.89176 2.96213 5.54097 2.6875C6.19019 2.41291 7.21647 2.57356 7.96569 2.57356Z",
    fill: "#93E300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8028 4.16291L11.1745 5.41625L10.0086 5.9571C9.48582 5.43428 8.76348 5.11094 7.96582 5.11094V2.57353C8.68851 2.57353 9.69066 2.40235 10.3212 2.65882C10.998 2.9341 11.2943 3.65457 11.8028 4.16291Z",
    fill: "#FFF375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3925 8.00009L12.1145 8.31259L10.8547 8.00009C10.8547 7.2024 10.5314 6.48009 10.0085 5.95727L11.8027 4.16309H11.8031C12.3114 4.67143 13.0319 4.96771 13.3072 5.64459C13.5636 6.27518 13.3925 7.2774 13.3925 8.00009Z",
    fill: "#FFC34D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3925 8C13.3925 8.72272 13.7825 9.63116 13.526 10.2617C13.2507 10.9387 12.3113 11.3288 11.8027 11.837L10.6183 11.2776L10.0085 10.0428C10.5314 9.52003 10.8547 8.79769 10.8547 8.00003H13.3925V8Z",
    fill: "#FF3377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8029 11.8372C11.3117 12.3282 10.8209 13.038 10.1717 13.3126C9.52251 13.5872 8.71504 13.4266 7.96582 13.4266V10.8891C8.76351 10.8891 9.48582 10.5658 10.0086 10.043L11.8029 11.8372Z",
    fill: "#FF5CA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96592 13.4263L8.27842 14.7603L7.96592 15.9996C5.76145 15.9906 3.76773 15.09 2.32642 13.6394L2.9101 12.4307L4.12892 11.8369C5.11082 12.8189 6.46748 13.4263 7.96592 13.4263Z",
    fill: "#C331C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6395 13.6736C12.1932 15.1113 10.2005 15.9999 8.00001 15.9999C7.98873 15.9999 7.9771 15.9999 7.96582 15.9996V13.4263C9.46426 13.4263 10.8206 12.8188 11.8028 11.8369L13.1287 12.5378L13.6395 13.6736Z",
    fill: "#FF3377"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 8C15.9999 10.2178 15.0974 12.2251 13.6394 13.6737L11.8027 11.837C12.785 10.8554 13.3925 9.49875 13.3925 8L14.7187 7.6875L15.9999 8Z",
    fill: "#E50048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 7.99986H13.3926C13.3926 6.50142 12.7851 5.14477 11.8032 4.16286L12.4206 2.92036L13.6396 2.32617C15.0975 3.7748 16.0001 5.78211 16.0001 7.99986Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6395 2.32631L11.8032 4.163H11.8028C10.8206 3.18109 9.46423 2.57363 7.96582 2.57363L7.65332 1.40628L7.96582 0.00034375C7.9771 0 7.98873 0 8.00001 0C10.2005 0 12.1932 0.888625 13.6395 2.32631Z",
    fill: "#FFDE46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96592 0.000488281V2.57377C6.46751 2.57377 5.11082 3.18124 4.12892 4.16314L2.93101 3.59024L2.32642 2.36064C3.76773 0.91002 5.76145 0.00942578 7.96592 0.000488281Z",
    fill: "#00DA26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12881 4.16285C3.14687 5.14476 2.53941 6.50141 2.53941 7.99985L1.17709 8.31235L0 7.99985C0 5.79935 0.888625 3.80666 2.32631 2.36035L4.12881 4.16285Z",
    fill: "#33DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12881 11.837L2.32631 13.6395C0.888625 12.1932 0 10.2005 0 8H2.53941C2.53941 9.49844 3.14687 10.8551 4.12881 11.837Z",
    fill: "#194D80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1632_706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPickerIcon);
export default __webpack_public_path__ + "static/media/color_picker_icon.d98635d9b8cfd51e5f7384c4e802a9f3.svg";
export { ForwardRef as ReactComponent };